import { LookupModelSearchEvent } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutDriverRevenueReport } from "./autogen/AutogenLayoutDriverRevenueReport";

export class DriverRevenueReport extends AutogenLayoutDriverRevenueReport {
    _containerEnabled: boolean;

    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxInclude.selectedItem = this.textboxInclude.items[0];
        this.textboxGoupBy.selectedItem = this.textboxGoupBy.items[0];
        this._containerEnabled = getDispatchControlBoolean("is_container_active", false);
        this.toggleContainerEnabled(this._containerEnabled);
    }

    private toggleContainerEnabled(isEnabled: boolean) {
        this.excludabletextboxSteamship.enabled = isEnabled;
        this.excludabletextboxSteamship.visible = isEnabled;
        this.textboxInclude.enabled = isEnabled;
        this.textboxInclude.visible = isEnabled;
    }

    textboxSteamshipLineBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y"
    }

    excludabletextboxFleetIdTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }
}
